import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { canAccessCustomerArea } from '../utils/authAccess';
import { savePendingVerifyEmail } from '../utils/emailVerification';
import type { ReactNode } from 'react';

interface ProtectedRouteProps {
  children: ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="container empty-state">
        <p>Yükleniyor...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!canAccessCustomerArea(user)) {
    if (user?.email) {
      savePendingVerifyEmail(user.email);
    }
    return (
      <Navigate
        to="/auth/verify-email-pending"
        state={{
          email: user?.email,
          message: 'Giriş yapabilmek için e-posta adresinizi doğrulamanız gerekiyor.',
        }}
        replace
      />
    );
  }

  return children;
}
